<template>
  <div>
    <header-component />

    <div class="checkout">
      <div class="w1300">
        <div class="tle">
          <h2 class="tit-36 fw700 cor-000">安全结账</h2>
        </div>
        <div class="box flex-sb">
          <div class="left">
            <div class="smTit">
              <h3 class="fw700 cor-000 tit-16">配送地址</h3>
            </div>
            <div class="formlist">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item prop="name">
                  <el-input
                    v-model="ruleForm.name"
                    placeholder="姓名"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="tel">
                  <el-input
                    v-model="ruleForm.tel"
                    placeholder="手机号"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="address" class="mobile-cascader-item">
                  <el-cascader
                    v-if="isPc"
                    v-model="ruleForm.address"
                    :options="optionsnative_place"
                    placeholder="省份 | 城市 | 区县"
                    @change="handleAddressChange"
                  />

                  <!-- 移动端：Vant 级联选择器（底部弹出，适配移动端） -->
                  <div v-else class="vant-cascader-wrap">
                    <!-- 显示已选值的输入框（只读） -->
                    <el-input
                      v-model="addressText"
                      placeholder="省份 | 城市 | 区县"
                      readonly
                      @click.native="showVantCascader = true"
                    />
                    <!-- Vant 弹窗 + 级联选择器 -->
                    <van-popup
                      v-model="showVantCascader"
                      position="bottom"
                      round
                      class="vant-cascader-popup"
                    >
                      <van-cascader
                        v-model="vantCascaderValue"
                        :options="vantAreaOptions"
                        :field-names="{
                          text: 'text',
                          value: 'value',
                          children: 'children',
                        }"
                        :columns-num="3"
                        @close="onVantCascaderClose"
                        @finish="onVantCascaderFinish"
                        title="选择省市区"
                      />
                    </van-popup>
                  </div>
                </el-form-item>

                <el-form-item prop="detailAddress">
                  <el-input
                    v-model="ruleForm.detailAddress"
                    placeholder="详细地址"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>

            <div class="delivery">
              <div class="smTit">
                <h3 class="fw700 cor-000 tit-16">配送方式</h3>
              </div>
              <div class="con mt-20">
                <div class="tit tit-18">京东或顺丰</div>
                <div class="text tit-15 cor-9191 mt-10">
                  工作日、双休日与节假日均可送货
                </div>
              </div>
            </div>

            <div class="invoice">
              <div class="smTit">
                <h3 class="fw700 cor-000 tit-16">发票信息</h3>
              </div>
              <div class="noInvoice">
                <el-checkbox v-model="noInvoice">不需要发票</el-checkbox>
              </div>

              <div class="list">
                <!-- 单选卡片 -->
                <el-radio-group
                  class="radio-group mt-20"
                  v-model="invoiceSelected"
                  v-if="!noInvoice"
                >
                  <el-radio
                    :label="item"
                    v-for="item in invoiceList"
                    :key="item.id"
                  >
                    <div class="info">
                      <div class="tit1 tit-12 cor-8080">
                        {{
                          item.invoiceType === 1
                            ? "企业数电普票"
                            : "企业数电专票"
                        }}
                      </div>
                      <div class="tit2 tit-14 cor-000">
                        <span class="line1">{{ item.invoiceTit }}</span>
                      </div>
                      <div class="tit3 tit-12 cor-8080">
                        <span class="line1">{{ item.taxNumber }}</span>
                      </div>
                    </div>
                    <div class="icon">
                      <i class="el-icon-check"></i>
                    </div>
                    <div class="iconx" @click="showDialog(item)">
                      <i class="el-icon-edit-outline"></i>
                    </div>
                  </el-radio>

                  <div class="btn flex-cc" @click="showDialog">
                    <div class="con">
                      <i class="el-icon-circle-plus"></i>
                      <div class="tit-14 mt-10">添加发票抬头</div>
                    </div>
                  </div>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="smTit flex-sbc">
              <h3 class="fw700 cor-000 tit-16">订单详情</h3>
              <div
                class="edit tit-15 cor-4090E5 cur"
                @click="$router.push('/shoppingCart')"
              >
                <i class="el-icon-edit"></i> <span>编辑购物车</span>
              </div>
            </div>

            <div class="order_list">
              <ul>
                <li class="flex-c" v-for="l in shangpinlie">
                  <div class="imgBox">
                    <el-image :src="l.tu" fit="contain"></el-image>
                  </div>
                  <div class="info">
                    <div class="name">{{ l.ming }}{{ l.guigeming }}</div>
                    <div class="bom flex-sbc mt-20">
                      <div class="num tit-14 cor-6B6B">x{{ l.shuliang }}</div>
                      <div class="price">¥{{ l.jiage }}</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div class="totalCon">
              <div class="item">
                <div class="name">商品总金额</div>
                <div class="price">¥{{ totalAmount }}</div>
              </div>
              <div class="item">
                <div class="name">运费</div>
                <div class="price cor-8A8A">¥{{ freight }}</div>
              </div>
              <div class="item">
                <div class="name">优惠券</div>

                <!-- 无可用优惠券时展示 -->
                <div
                  v-if="!shu.quan || shu.quan.length == 0"
                  class="couponPriceNo tit-14 cor-8A8A"
                >
                  无可使用优惠券
                </div>

                <!-- 有可用优惠券时展示 -->
                <div v-else class="coupon-section">
                  <div
                    class="tit-14 pon cur cor-red"
                    @click="showCouponDialog = true"
                  >
                    <span>选择优惠券</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>

                <!-- 优惠券弹窗 -->
                <el-dialog
                  :visible.sync="showCouponDialog"
                  class="couponDialog"
                  title="选择优惠券"
                >
                  <div class="coupon-list">
                    <div
                      v-for="(coupon, index) in shu.quan"
                      :key="index"
                      class="coupon-item"
                      :class="{
                        'coupon-selected': coupon === selectedCoupon,
                      }"
                      @click="selectCoupon(coupon)"
                    >
                      <div class="coupon-content">
                        <div class="coupon-top flex-sbc">
                          <div class="coupon-amount tit-24 fw700 cor-4090E5">
                            ¥{{ coupon.e }}
                          </div>
                          <div class="coupon-info">
                            <div class="coupon-name tit-16 cor-333">
                              <span class="line1"> {{ coupon.biaoti }}</span>
                            </div>
                            <div class="coupon-condition tit-14 cor-999 mt-10">
                              {{ coupon.tiaojian }}
                            </div>
                          </div>
                        </div>
                        <div class="coupon-time mt-20 cor-999 tit-14">
                          有效时间： {{ coupon.kaishi_shijian }}-{{
                            coupon.jieshu_shijian
                          }}
                        </div>
                      </div>
                      <div
                        v-if="coupon === selectedCoupon"
                        class="coupon-check"
                      >
                        <i class="el-icon-check"></i>
                      </div>
                    </div>
                  </div>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="showCouponDialog = false"
                      >取消</el-button
                    >
                    <el-button type="primary" @click="Couponget"
                      >确认使用</el-button
                    >
                  </div>
                </el-dialog>
              </div>

              <!-- 选中优惠券后，展示优惠信息和应付金额 -->
              <div class="item item2" v-if="selectedCoupon">
                <!-- <div class="name">优惠信息</div> -->
                <div class="coupon-used flex-sbcw" style="width: 100%">
                  <span class="tit-14 cor-8A8A">{{
                    selectedCoupon.biaoti
                  }}</span>
                  <span class="tit-14 cor-red"> -¥{{ selectedCoupon.e }} </span>
                </div>
              </div>

              <!-- 应付金额 -->
              <div class="item">
                <div class="name">应付金额</div>
                <div class="price tit-18 fw700">¥{{ payAmount }}</div>
              </div>
            </div>

            <div class="subCheck tit-14">
              <el-checkbox v-model="form.agreeTerms">
                提交订单即表示我同意优理奇商城的
              </el-checkbox>
              <el-link
                type="primary"
                @click="dealDialog('deal1')"
                :underline="false"
              >
                《商城订购及售后规则》
              </el-link>
              、
              <el-link
                type="primary"
                @click="dealDialog('deal2')"
                :underline="false"
              >
                《技术能力确认协议》
              </el-link>
              、
              <el-link
                type="primary"
                @click="dealDialog('deal3')"
                :underline="false"
              >
                《隐私权政策》
              </el-link>
              及
              <el-link
                type="primary"
                @click="dealDialog('deal4')"
                :underline="false"
              >
                《用户协议》
              </el-link>
            </div>

            <div class="subBtn">
              <el-button type="primary" @click="submitOrder">
                提交订单
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 发票弹窗 -->
    <el-dialog
      title="添加新发票"
      :visible.sync="dialogVisible"
      class="invoiceDialog"
    >
      <el-form
        :model="dialogRuleForm"
        :rules="dialogRules"
        ref="dialogRuleForm"
      >
        <el-form-item prop="invoiceType">
          <el-radio-group v-model="dialogRuleForm.invoiceType">
            <el-radio :label="1">企业数电普票</el-radio>
            <el-radio :label="2">企业数电专票</el-radio>
            <el-radio :label="3">个人数电普票</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item prop="invoiceTit">
          <el-input
            v-model="dialogRuleForm.invoiceTitle"
            placeholder="发票抬头"
          ></el-input>
        </el-form-item>

        <el-form-item prop="taxNumber">
          <el-input
            v-model="dialogRuleForm.taxNumber"
            placeholder="单位税号"
          ></el-input>
        </el-form-item>

        <el-form-item prop="email">
          <el-input
            v-model="dialogRuleForm.email"
            placeholder="电子邮箱"
          ></el-input>
        </el-form-item>

        <el-form-item prop="bank">
          <el-input
            v-model="dialogRuleForm.bank"
            placeholder="开户银行"
          ></el-input>
        </el-form-item>

        <el-form-item prop="account">
          <el-input
            v-model="dialogRuleForm.bankAccount"
            placeholder="银行账号"
          ></el-input>
        </el-form-item>

        <el-form-item prop="address">
          <el-input
            v-model="dialogRuleForm.companyAddress"
            placeholder="企业地址"
          ></el-input>
        </el-form-item>

        <el-form-item prop="phone">
          <el-input
            v-model="dialogRuleForm.companyPhone"
            placeholder="企业电话"
          ></el-input>
        </el-form-item>

        <!-- 设为默认 -->
        <el-form-item>
          <el-checkbox v-model="dialogRuleForm.isDefault">
            设为默认
          </el-checkbox>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialogFooter">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="Tijiaofapiao">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 隐私政策等弹窗 -->
    <el-dialog
      title=""
      class="dealDialog"
      :visible.sync="dealdialogVisible"
      width="50%"
      top="0"
    >
      <div class="info">
        <div class="deal1">
          <div class="tit tit-24 fw700 txt-c cor-333">
            《{{ wenzhangxq.biaoti }}》
          </div>
          <div v-html="wenzhangxq.neirong"></div>
        </div>
        <!-- <div v-if="dialogContent === 'deal2'" class="deal2">
					<div class="tit tit-24 fw700 txt-c cor-333">《技术能力确认协议》</div>
				</div>
				<div v-if="dialogContent === 'deal3'" class="deal3">
					<div class="tit tit-24 fw700 txt-c cor-333">《隐私权政策》</div>
				</div>

				<div v-if="dialogContent === 'deal4'" class="deal4">
					<div class="tit tit-24 fw700 txt-c cor-333">《用户协议》</div>
				</div> -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dealdialogVisible = false">
          确 定
        </el-button>
      </span>
    </el-dialog>

    <footer-component />
  </div>
</template>

<script>
let that;
import headerComponent from "@/components/header.vue";
import footerComponent from "@/components/footer.vue";
import { Cascader, Popup } from "vant";

// 引入省市区
import {
  provinceAndCityData, //省市二级联动数据,汉字+code
  pcTextArr, // 省市区三级联动数据
  regionData, // 省市联动数据，纯汉字
  pcaTextArr, //省市区联动数据，纯汉字
  codeToText, // 是个大对象，属性是区域码，属性值是汉字 用法例如：codeToText[‘110000’]输出北京市
} from "element-china-area-data";

// 转换数据格式适配vant组件
const transformAreaData = (data) => {
  return data.map((item) => ({
    text: item.label || item.name || item.text,
    value: item.value || item.code || item.id,
    children: item.children ? transformAreaData(item.children) : [],
  }));
};

const optionsnative_place = pcaTextArr;

export default {
  name: "OrderConfirmIndex",

  components: {
    headerComponent,
    footerComponent,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
  },

  data() {
    return {
      isPc: true, // 是否为PC端
      showVantCascader: false, // 移动端选择器弹窗显示状态
      vantCascaderValue: "", // Vant级联选择器绑定值（字符串类型）
      addressText: "", // 移动端显示的地址文本
      ruleForm: {
        name: "",
        tel: "",
        address: [],
        detailAddress: "",
      }, // 地址表单
      optionsnative_place, // 省市区
      // Vant组件专用的省市区数据
      vantAreaOptions: [],
      // 表单验证
      rules: {
        name: [
          {
            required: true,
            message: "请填写姓名",
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            message: "请填写手机号",
            trigger: "blur",
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: "请选择省市区",
            // trigger: "blur",
            trigger: "change",
          },
          {
            type: "array",
            min: 3,
            message: "请选择完整的省市区信息",
            trigger: "change",
          }, // 确保选到区县
        ],

        detailAddress: [
          {
            required: true,
            message: "请填写详细地址",
            trigger: "blur",
          },
        ],
      },

      // 弹窗信息
      dialogRuleForm: {
        invoiceType: 1,
        invoiceTit: "",
        invoiceTitle: "",
        taxNumber: "",
        email: "",
        bank: "",
        account: "",
        address: "",
        phone: "",
        bankAccount: "",
        companyAddress: "",
        companyPhone: "",
        isDefault: false,
      }, // 发票表单

      noInvoice: false, // 不需要发票
      invoiceSelected: null, // 选中的发票
      dialogVisible: false, // 发票弹窗

      invoiceList: [], // 发票列表

      dialogRules: {
        invoiceType: [
          {
            required: true,
            message: "请选择发票类型",
            trigger: "change",
          },
        ],
        invoiceTitle: [
          {
            required: true,
            message: "请填写发票抬头",
            trigger: "blur",
          },
        ],
        taxNumber: [
          {
            required: true,
            message: "请填写单位税号",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请填写电子邮箱",
            trigger: "blur",
          },
        ],
        bank: [
          {
            // required: true,
            message: "请填写开户银行",
            trigger: "blur",
          },
        ],
        bankAccount: [
          {
            // required: true,
            message: "请填写银行账号",
            trigger: "blur",
          },
        ],
        companyAddress: [
          {
            // required: true,
            message: "请填写企业地址",
            trigger: "blur",
          },
        ],
        companyPhone: [
          {
            // required: true,
            message: "请填写企业电话",
            trigger: "blur",
          },
        ],
      },

      // 商品总金额
      totalAmount: 880000,
      // 运费
      freight: 0,
      // 优惠券列表，模拟数据，实际可从接口获取
      coupons: [
        {
          name: "灵犀X1整机组件套餐优惠券灵犀X1整机组件套餐优惠券",
          amount: 10000,
          condition: "满99000可用",
          startTime: "2025/06/03",
          endTime: "2025/06/30",
        },
        {
          id: 2,
          name: "新用户专享优惠券",
          amount: 5000,
          condition: "满50000可用",
          startTime: "2025/06/01",
          endTime: "2025/06/30",
        },
      ],
      selectedCoupon: null, // 选中的优惠券
      showCouponDialog: false, // 优惠券弹窗

      dealdialogVisible: false,
      dialogContent: "", // 用于存储当前要显示的弹窗内容类型

      form: {
        agreeTerms: false,
      },
      // 后台数据
      sid: 0,
      num: 1,
      shu: {},
      shangpinlie: [],
      wenzhangxq: {},
      guigeid: 0,
      quanid: 0,
    };
  },
  watch: {
    noInvoice(newVal) {
      if (newVal) {
        this.invoiceSelected = null;
      }
    },
    invoiceSelected(newVal) {
      if (newVal) {
        this.noInvoice = false;
      }
    },
  },

  // created() {
  // 	that = this;
  // 	if(this.$route.params && this.$route.params.id){
  // 		this.sid = this.$route.params.id;
  // 	}
  // 	if(this.$route.params && this.$route.params.num){
  // 		this.num = this.$route.params.num;
  // 	}
  // 	if(this.$route.params && this.$route.params.guigeid){
  // 		this.guigeid = this.$route.params.guigeid;
  // 	}
  // 	console.log(this.$route.params)
  // 	this.CSH();
  // },
  created() {
    this.sid = this.$route.params.id || 0;
    this.num = Number(this.$route.params.num) || 1;
    this.guigeid = Number(this.$route.params.guigeid) || 0;
    this.CSH();
  },

  mounted() {
    // var yonghu = this.$qu("yonghux");
    // this.headers.kouling = yonghu.kouling;

    // 初始化判断终端类型
    this.judgeDevice();
    this.vantAreaOptions = this.transformAreaData(this.optionsnative_place);
    // 初始化：如果已有地址值，同步到Vant选择器
    if (this.ruleForm.address && this.ruleForm.address.length) {
      // 取最后一个值作为Vant组件的值
      this.vantCascaderValue = this.ruleForm.address[this.ruleForm.address.length - 1];
      this.updateAddressText(this.ruleForm.address);
    }
  },
  computed: {
    // 计算可用优惠券
    availableCoupons() {
      const total = this.totalAmount + this.freight;
      return this.coupons.filter((coupon) => {
        const conditionNum = parseInt(coupon.condition.match(/\d+/)[0]);
        return total >= conditionNum;
      });
    },
    // 计算应付金额
    payAmount() {
      const total = this.totalAmount + this.freight;
      return this.selectedCoupon ? total - this.selectedCoupon.e : total;
    },
  },

  methods: {
    // 判断设备类型（PC/移动端）
    judgeDevice() {
      const userAgent = navigator.userAgent;
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent,
      );
      this.isPc = !isMobile;
    },

    // 转换省市区数据格式适配vant组件
    transformAreaData(data) {
      if (!data || !Array.isArray(data)) return [];
      return data.map((item) => {
        // 确保每个节点都有完整的结构
        const transformedItem = {
          text: item.label || item.name || item.text || "",
          value: item.value || item.code || item.id || "",
          children: item.children ? this.transformAreaData(item.children) : [],
        };
        // 如果children为空数组，删除children属性（避免vant组件显示异常）
        if (transformedItem.children && transformedItem.children.length === 0) {
          delete transformedItem.children;
        }
        return transformedItem;
      });
    },
    // 更新地址文本显示
    updateAddressText(addressArray) {
      if (addressArray && addressArray.length >= 3) {
        this.addressText = `${addressArray[0]} ${addressArray[1]} ${
          addressArray[2]
        }`;
      } else {
        this.addressText = "";
      }
    },
    // Vant级联选择器关闭事件
    onVantCascaderClose() {
      this.showVantCascader = false;
    },
    // Vant级联选择器完成选择事件
    onVantCascaderFinish({ selectedOptions }) {
      // 获取选中的文本数组（用于Element表单验证）
      const selectedValues = selectedOptions.map((option) => option.text);
      // 获取最后一个选中的值（用于Vant组件）
      const vantValue = selectedOptions[selectedOptions.length - 1].value;
      
      this.vantCascaderValue = vantValue;
      this.ruleForm.address = selectedValues;
      this.updateAddressText(selectedValues);
      this.showVantCascader = false;

      // 触发验证
      this.$nextTick(() => {
        this.$refs.ruleForm.validateField("address");
      });
    },

    // 后台数据
    CSH: function() {
      that = this;
      that.$post(
        "m=limitao&k=dingdan&c=querendingdan",
        {
          ids: that.sid,
          shuliang: that.num,
          guigeid: that.guigeid,
          // dizhiid: dizhi.id
        },
        function(shu) {
          if (shu.shi == 1) {
            that.shu = shu.shu;
            if (that.shu.gouwuchelie) {
              that.shangpinlie = that.shu.gouwuchelie[0].shangpin;
              that.totalAmount = Number(shu.shu.zongjia);
            }
            if (that.shu.morendizhi) {
              that.ruleForm.name = that.shu.morendizhi.ming;
              that.ruleForm.tel = that.shu.morendizhi.dianhua;
              that.ruleForm.address = that.shu.morendizhi.shengshiqu;
              that.ruleForm.detailAddress = that.shu.morendizhi.dizhi;
            }
            if (that.shu.morenfapiao) {
              that.invoiceList = that.shu.morenfapiao;
            }
            // that.totalAmount =that.totalAmount.toFixed(2)
          } else if (shu.shi == -2) {
            that.$xiaoxi(shu.shu);

            setTimeout(function() {
              that.$houtui();
            }, 2000);
          } else {
            that.$xiaoxi(shu.shu);
          }
        },
      );
    },
    // 4. 手动触发地址验证（可选，增强体验）
    handleAddressChange() {
      this.$refs.ruleForm.validateField("address");
    },

    // 后台数据
    showDialog(e) {
      if (e && e.id) {
        this.dialogRuleForm = e;
        this.currentAction = "edit";
      } else {
        this.dialogRuleForm = {
          invoiceType: 1,
          invoiceTitle: "",
          taxNumber: "",
          email: "",
          bank: "",
          bankAccount: "",
          companyAddress: "",
          companyPhone: "",
          isDefault: false,
        };
        this.currentAction = "add";
      }
      this.dialogVisible = true;
    },
    // 添加发票数据
    Tijiaofapiao() {
      var that = this;
      // that.$post("k=invoice&c=xiugai", that.dialogRuleForm, function(s) {
      //   if (s.shi == 1) {
      //     if (that.currentAction === "add") {
      //       // 添加新地址
      //       that.$message.success("添加成功");
      //     } else {
      //       that.$message.success("修改成功");
      //     }
      //     that.dialogVisible = false;
      //     that.dialogRuleForm = {};
      //   } else {
      //     that.$message.error(s.shu);
      //   }
      //   that.CSH();
      // });
      // 表单验证
      that.$refs.dialogRuleForm.validate((valid) => {
        if (valid) {
          that.$post("k=invoice&c=xiugai", that.dialogRuleForm, function(s) {
            if (s.shi == 1) {
              if (that.currentAction === "add") {
                // 添加新地址
                that.$message.success("添加成功");
              } else {
                that.$message.success("修改成功");
              }
              that.dialogVisible = false;
              that.CSH();
            } else {
              that.$message.error(s.shu);
            }
          });
        } else {
          that.$message.error("请填写完整的发票信息");
          return false;
        }
      });
    },
    saveInvoice() {
      this.$refs.dialogRuleForm.validate((valid) => {
        if (valid) {
          // 创建新对象保存发票信息，避免引用问题
          const newInvoice = {
            ...this.dialogRuleForm,
            id: Date.now(), // 添加唯一ID
          };

          // 添加到发票列表
          this.invoiceList.unshift(newInvoice);

          // 如果是默认发票，自动选中
          if (newInvoice.isDefault) {
            this.invoiceSelected = newInvoice;
          }

          this.dialogVisible = false;
          this.$message.success("发票添加成功");
        }
      });
    },
    // 选择优惠券
    selectCoupon(coupon) {
      this.selectedCoupon = this.selectedCoupon === coupon ? null : coupon;
      console.log(this.selectedCoupon, "this.selectedCoupon");
    },
    Couponget() {
      this.showCouponDialog = false;
      this.quanid = this.selectedCoupon.id;
    },
    // 确认使用优惠券
    confirmCoupon() {
      this.showCouponDialog = false;
    },

    // 显示弹窗
    dealDialog(type) {
      var wming = "";
      var that = this;
      that.dialogContent = type;
      if (type == "deal1") {
        wming = "商城订购及售后规则";
      } else if (type == "deal2") {
        wming = "技术能力确认协议";
      } else if (type == "deal3") {
        wming = "隐私政策";
      } else if (type == "deal4") {
        wming = "用户协议";
      }
      that.$post("k=wenzhang&c=xiangqing", { id: wming }, function(shu) {
        that.wenzhangxq = shu.shu;
        that.dealdialogVisible = true;
      });
    },

    submitForm(formName) {
      console.log(this.$refs[formName]);

      this.$refs[formName].validate((valid) => {
        console.log(valid);

        if (valid) {
          alert("submit!");

          // 模拟提交表单
          setTimeout(() => {
            this.$message.success("提交成功");
          }, 1000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    submitOrder() {
      // 提交订单逻辑
      var that = this;
      var fapiaoid = "";
      // 1. 验证配送地址表单
      that.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          that.$message.error("请填写完整的配送地址信息");
          return;
        }
        if (!that.$qu("yonghux")["id"]) {
          that.$message.error("请先登录");
          return;
        }
        // 2. 检查发票要求
        if (!that.noInvoice && !that.invoiceSelected) {
          that.$message.error('请选择发票或勾选"不需要发票"');
          return;
        }

        // 3. 检查是否同意协议
        if (!that.form.agreeTerms) {
          that.$message.error("请先阅读并同意相关协议");
          return;
        }

        // 全部通过验证按钮才取消禁用状态
        // 4. 检查是否需要勾选规格
        console.log(333);
        // 模拟API调用
        that
          .$confirm("确认提交订单吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            // 实际应用中这里应该是API调用
            // this.$api.order.submit(orderData).then(response => {...})
            // 模拟成功响应
            setTimeout(() => {
              // this.$message.success("订单提交成功");
              // // 跳转到订单详情或支付页面
              // this.$router.push("/order/success");
              // uni.$emit('GWC')
              if (that.invoiceSelected && that.invoiceSelected.id) {
                fapiaoid = that.invoiceSelected.id;
              } else {
                fapiaoid = "";
              }
              that.$post(
                "m=limitao&k=dingdan&c=chuangjiandingdan",
                {
                  ids: that.sid,
                  guigeid: that.guigeid ? that.guigeid : "",
                  shuliang: that.num,
                  dizhi: that.ruleForm,
                  zongjia: that.shu.zongjia,
                  quan: that.quanid,
                  fapiao: fapiaoid,
                  xuyaofapiao: that.noInvoice,
                },
                function(shu) {
                  if (shu.shi == 1) {
                    that.$router.push({
                      name: "orderPayment",
                      params: { id: shu.shu.dingdanid, ids: that.sid },
                    });
                  } else {
                    that.$message.error(shu.shu);
                  }
                },
              );
            }, 1000);
          })
          .catch(() => {
            that.$message.info("已取消提交");
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.checkout {
  padding: 0.6rem 0 1rem;

  .box {
    margin-top: 0.4rem;

    .smTit {
      padding-bottom: 0.1rem;
      border-bottom: 1px solid #333333;
      margin-bottom: 0.15rem;
    }
  }

  .left {
    width: 56%;

    .formlist {
      margin-top: 0.3rem;

      /deep/ .el-form {
        .el-form-item {
          .el-input__inner {
            height: 0.57rem;
            min-height: 36px;
          }
        }
      }
    }

    // 配送
    .delivery {
      margin-top: 0.4rem;

      .con {
        padding: 0.35rem 0.4rem;
        border: 1px solid #4090e5;
        border-radius: 5px;
      }
    }

    // 发票
    .invoice {
      margin-top: 0.4rem;

      .noInvoice {
        text-align: right;
      }

      .list .radio-group {
        display: grid;
        grid-template-columns: repeat(3, calc(34% - 0.2rem));
        gap: 0.2rem;
      }

      .radio-group {
        /deep/ .el-radio {
          background: #fcfcfc;
          border-radius: 0.1rem;
          margin: 0;
          display: flex;
          align-items: center;
          border: 1px solid transparent;
          overflow: hidden;
          height: 1rem;
          min-height: 70px;

          .el-radio__input {
            display: none;
          }

          .icon {
            position: absolute;
            right: 5px;
            bottom: 5px;
            background: #4090e5;
            color: #fff;
            opacity: 0;
          }
          .iconx {
            position: absolute;
            right: 2%;
            // bottom: 1px;
            top: 4%;
            color: #4090e5;
          }
          .el-radio__label {
            padding: 0.1rem;
            width: 100%;
          }

          .tit2 {
            margin: 0.1rem 0;
          }

          &.is-checked {
            border-color: #4090e5;

            .icon {
              opacity: 1;
            }
          }
        }
      }

      .btn {
        background: #fcfcfc;
        border-radius: 0.1rem;
        text-align: center;
        height: 1rem;
        min-height: 70px;

        i {
          font-size: var(--font26);
          color: #333;
        }
      }
    }
  }

  .right {
    width: 33%;

    .order_list {
      ul li {
        padding: 0.2rem 0;
        border-bottom: 1px solid #ebebeb;

        .imgBox {
          width: 1rem;
          height: 1rem;

          .el-image {
            display: block;
            width: 100%;
            height: 100%;
          }
        }

        .info {
          margin-left: 0.3rem;
          flex: 1;
          max-width: calc(100% - 1.3rem);
        }
      }
    }

    .totalCon {
      margin-top: 0.4rem;
      padding: 0.1rem 0.2rem;
      background: #f6f6f6;
      border-radius: 0.1rem;

      .item {
        margin: 0.2rem 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > .name {
          font-size: var(--font14);
          color: #8c8c8c;
          word-break: break-all;
        }
      }
    }

    .subCheck {
      margin-top: 0.15rem;

      /deep/ .el-checkbox {
        .el-checkbox__label {
          font-size: var(--font14);
        }
        .el-checkbox__input {
          .is-checked + .el-checkbox__label {
            color: #333;
          }
        }
      }

      .el-link.el-link--primary {
        color: #005ccd;
        font-size: var(--font14);
      }
    }

    .subBtn {
      margin-top: 1rem;
      text-align: center;

      .el-button {
        width: 100%;
        background: #4090e5;
        border-radius: 0.27rem;
        height: 0.52rem;
        min-height: 40px;
        box-sizing: border-box;

        &.is-disabled {
          opacity: 0.6;
        }
      }
    }
  }
}

// 省市区样式
.el-cascader {
  width: 100%;
}

// 发票弹窗
/deep/ .invoiceDialog {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-dialog {
    width: 42%;
    max-width: 800px;
    margin: auto !important;

    .el-radio-group {
      display: inline-flex;
      flex-wrap: wrap;
      gap: 0.2rem;
      .el-radio {
        border: 1px solid #d2d3d4;
        color: #d2d3d4;
        padding: 0.15rem 0.3rem;
        border-radius: 5px;
        margin: 0;

        .iconx {
          font-size: var(--font14);
        }

        .el-radio__input {
          display: none;
        }

        &.is-checked {
          border-color: #4090e5;
          color: #4090e5;
        }
      }
    }
  }
}

// 优惠卷弹窗
/deep/ .couponDialog {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-dialog {
    width: 800px;
    max-width: 92%;
    margin: auto !important;
  }

  .coupon-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.3rem;

    .coupon-item {
      padding: 0.2rem;
      border: 1px solid #d2d3d4;
      border-radius: 5px;
      position: relative;

      .coupon-amount {
        flex-shrink: 0;
        margin-right: 0.1rem;
      }

      .coupon-check {
        position: absolute;
        right: 5px;
        bottom: 5px;
        background: #4090e5;
        color: #fff;
        padding: 0 3px;
      }

      &.coupon-selected {
        border-color: #4090e5;
      }
    }
  }
}

// 隐私弹窗
/deep/ .dealDialog {
  .el-dialog {
    top: 5vh;
    margin: 5vh auto;

    .el-dialog__body {
      max-height: 80vh;
      overflow-y: auto;
      .info {
        color: initial;

        h2 {
          margin: revert;
        }
        ol {
          margin: revert;
          padding: revert;
          li {
            margin: inherit;
            padding: revert;
            list-style: inherit;
          }
        }

        ul {
          margin: revert;
          padding: revert;
          li {
            margin: inherit;
            padding: revert;
            list-style: initial;
          }
        }
      }
    }

    .el-dialog__footer {
      text-align: center;

      .el-button--primary {
        border: 0;
        background: #000000;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .checkout .box {
    flex-wrap: wrap;
  }
  .checkout .left {
    width: 100%;
  }
  .checkout .right {
    width: 100%;
    margin-top: 0.5rem;
  }

  .checkout .left .formlist {
    .el-form-item {
      margin-bottom: 16px;
    }
  }

  .checkout .right .order_list ul li .imgBox {
    width: 1.5rem;
    height: 1.5rem;
  }

  /deep/ .invoiceDialog .el-dialog {
    width: 90%;

    .el-dialog__body {
      padding-top: 0;
      padding-bottom: 0;
    }

    .el-form-item {
      margin-bottom: 16px;
    }
  }

  /deep/ .dealDialog .el-dialog {
    width: 96% !important;
  }
}
</style>